import Breakpoint from "@core/scripts/helper/breakpoint.js";

export default function isBeyondEdgeSlidingEnabled() {
    return Breakpoint.keyIsIn(['small', 'medium']);
}
